import {
  EPersonalityTypes,
  IPersonalityReportGraph,
} from 'affiny-core/modules/personalityReport/types';
import { Box, Flex, Grid, rem } from 'affiny-ui/src';
import React, { useState } from 'react';
import { PersonalityReportLayerBottomChapterNavigation } from './PersonalityReportLayerBottomChapterNavigation';
import { PersonalityReportLayerVisionSubChapter } from './PersonalityReportLayerVisionSubChapter';
import { PersonalityReportLayerVisionSubMenu } from './PersonalityReportLayerVisionSubMenu';

interface IPersonalityReportLayerVisionChapter {
  graphs: IPersonalityReportGraph[];
  personalityType: EPersonalityTypes;
  setSection: (arg: string) => void;
}

export const PersonalityReportLayerVisionChapter = ({
  graphs,
  personalityType,
  setSection,
}: IPersonalityReportLayerVisionChapter) => {
  const [activeTitle, setActiveTitle] = useState(graphs[0].id);

  return (
    <Box>
      <Grid height="100%">
        <Flex gridColumn="span 4" flexDirection="column">
          <Box position="sticky" top={rem(161)}>
            <PersonalityReportLayerVisionSubMenu
              graphs={graphs}
              nbOfItem={graphs.length - 1}
              activeTitle={activeTitle}
            />
          </Box>
        </Flex>
        <Flex gridColumn="span 8" flexDirection="column">
          {graphs.map(graph => (
            <PersonalityReportLayerVisionSubChapter
              key={graph.id}
              graph={graph}
              personalityType={personalityType}
              setTitle={setActiveTitle}
            />
          ))}
          <PersonalityReportLayerBottomChapterNavigation
            chapter="vision"
            setSection={setSection}
          />
        </Flex>
      </Grid>
    </Box>
  );
};
